import { takeLatest, put, all, call } from "redux-saga/effects";
import { getDelayedData, getInfoDeliveryFlow } from "../services/api";
import { DELAYED_DATA_ACTIONS } from "../reducers/actionTypes";
import { actions as delayDataActions } from "@reducers/delayDataReducer";

function* getDelayedDataSaga() {
  try {
    const { data } = yield call(getDelayedData);
    if (data?.deliveryFlowEnabled) {
      const { deliveryFlowEnabled = false, deliveryFlowInfo = {} } = data || {};
      const { orders } = deliveryFlowInfo || {};
      data.deliveryFlowEnabled =
        Array.isArray(orders) && orders.length !== 0 && deliveryFlowEnabled;
      if (!data?.deliveryFlowEnabled) {
        data.deliveryFlowInfo = {
          ordersCount: 0,
          orders: [],
          meta: {},
        };
      }
    }
    yield put(delayDataActions.fetchedDelayedData(data));
  } catch (error) {
    yield put(delayDataActions.failedFetchDelayedData(error));
  }
}

function* getDeliveryFlowInfoData() {
  try {
    const { data } = yield call(getInfoDeliveryFlow);
    if (data) {
      const { orders } = data || {};
      if (Array.isArray(orders) && orders.length !== 0)
        yield put(
          delayDataActions.updateDeliveryFlowInfo({
            deliveryFlowEnabled: true,
            deliveryFlowInfo: data,
          }),
        );
      else
        yield put(
          delayDataActions.updateDeliveryFlowInfo({
            deliveryFlowEnabled: false,
            deliveryFlowInfo: data,
          }),
        );
    }
  } catch (error) {
    console.log("error", error);
  }
}

export default function* root() {
  yield all([
    takeLatest(DELAYED_DATA_ACTIONS.FETCH_DELAYED_DATA, getDelayedDataSaga),
    takeLatest(DELAYED_DATA_ACTIONS.GET_DELIVERY_INFO, getDeliveryFlowInfoData),
  ]);
}
